import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../../static/images/logo_quinors@2x.png';
import tokens from '../theme/tokens';

// 실시간문의 마크 — 퀴노스 로고 그대로(2026-10-01 사용자 지시 "우리 로고로"). 흰 원 안에 로고, 밝은 배경에서는 주황 테두리(ring)
const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 'none',
    borderRadius: '50%',
    backgroundColor: tokens.surface,
    overflow: 'hidden',
  },
  ring: {
    border: `2px solid ${tokens.primary}`,
  },
  img: {
    display: 'block',
    height: 'auto',
  },
}));

function ChatMark({ size = 56, ring = false, className }) {
  const cs = useStyles();
  return (
    <span className={clsx(cs.root, ring && cs.ring, className)} style={{ width: size, height: size }} role="img" aria-label="퀴노스 실시간문의">
      <img className={cs.img} src={logo} alt="" style={{ width: Math.round(size * 0.7) }} />
    </span>
  );
}

export default ChatMark;
